// hooks/useAuth.ts
import { useContext } from "react";
import { AuthContext } from "context/AuthContext";

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth precisa estar dentro de <AuthProvider> (verifique index.tsx)");
  }
  return ctx;
}